import { api } from '@/services/api';
import { PendingRewardTotalsDto } from '@repo/common-types';

export const fundsRewardsManagerRest = async () => {
  const response = await api.post(`/v1/admin/rewards/fund-rewards-manager`);
  return response.data;
};

export const payRewardsRest = async () => {
  const response = await api.post(`/v1/admin/rewards/pay-rewards`);
  return response.data;
};

export const endRewardsDistributionRest = async () => {
  const response = await api.post(`/v1/admin/rewards/end-rewards-distribution`);
  return response.data;
};

export const getPendingWeeklyRakeSharePayoutsRest = async () => {
  const response = await api.get(`/v1/admin/rewards/pending-weekly-rake-share-payouts`);
  return response.data;
};

export const getPendingRewardsRest = async (): Promise<PendingRewardTotalsDto> => {
  const response = await api.get<PendingRewardTotalsDto>(`/v1/admin/rewards/pending-rewards`);
  return response.data;
};
